export interface Movie {
  id: string;
  title: string;
  category: string;
  region: string;
  year: string;
  rating: number;
  description: string;
  longDescription: string;
  coverImage: string;
  tags: string[];
  director: string;
  actors: string[];
  updateInfo: string;
  isHot: boolean;
  isNew: boolean;
}

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: 'movie',
    region: 'china',
    year: '2026',
    rating: 9.2,
    description: '太阳急速老化，持续膨胀，地球面临被吞没的危机。人类在地球表面建造巨型推进器，开启长达2500年的流浪之旅...',
    longDescription: '在《流浪地球3》中，太阳急速老化，持续膨胀，地球面临被吞没的危机。人类在地球表面建造巨型推进器，开启长达2500年的流浪之旅。第三部延续前作的宏大叙事，人类最终抵达比邻星系，却发现新的挑战正等待着他们。本片由中国著名导演执导，吴京、刘德华等原班人马悉数回归，视觉特效全面升级，为观众呈现一场震撼人心的科幻盛宴。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20science%20fiction%20movie%20poster%20featuring%20a%20giant%20planet%20Earth%20with%20massive%20engines%20in%20space%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20cinematic%20composition%2C%20epic%20scale%2C%20dark%20cosmic%20background%20with%20stars%2C%20clean%20minimal%20poster%20design%20with%20warm%20tones&width=600&height=800&seq=movie-cover-1&orientation=portrait',
    tags: ['科幻', '灾难', '冒险', '国产大片'],
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    updateInfo: 'HD高清',
    isHot: true,
    isNew: true,
  },
  {
    id: 'movie-2',
    title: '满江红',
    category: 'movie',
    region: 'china',
    year: '2023',
    rating: 8.7,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一个小兵与亲兵营副统领被卷入一场巨大的阴谋之中...',
    longDescription: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者离奇死亡，所携密信不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这场巨大的阴谋之中。宰相秦桧命两人限时一个时辰之内找到凶手，伴随危机四伏的深入调查，案件背后似乎隐藏着一场更大的阴谋。本片由张艺谋执导，沈腾、易烊千玺领衔主演，融合悬疑与喜剧元素，剧情层层反转。',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20historical%20drama%20movie%20poster%20set%20in%20Song%20Dynasty%2C%20dark%20courtyard%20with%20lanterns%2C%20red%20and%20black%20color%20scheme%2C%20mysterious%20atmosphere%2C%20traditional%20Chinese%20architecture%20background%2C%20cinematic%20lighting%2C%20clean%20poster%20design&width=600&height=800&seq=movie-cover-2&orientation=portrait',
    tags: ['悬疑', '历史', '喜剧', '国产'],
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    updateInfo: '4K超清',
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-3',
    title: '狂飙',
    category: 'tv',
    region: 'china',
    year: '2023',
    rating: 9.5,
    description: '刑警安欣与黑恶势力高启强之间长达二十年的正邪较量，展现了扫黑除恶的艰辛历程...',
    longDescription: '《狂飙》讲述了以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开的长达二十年的正邪较量。从2000年到2021年，故事跨越二十年，通过时代变迁中的人物命运，展现了扫黑除恶的艰辛历程。本剧由张译、张颂文领衔主演，剧情紧凑，演技炸裂，被誉为近年来最佳国产电视剧之一。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20two%20men%20facing%20each%20other%20in%20dark%20contrast%2C%20one%20in%20police%20uniform%20one%20in%20dark%20suit%2C%20dramatic%20tension%2C%20urban%20night%20background%2C%20intense%20gold%20and%20dark%20blue%20color%20palette%2C%20cinematic%20poster%20design&width=600&height=800&seq=movie-cover-3&orientation=portrait',
    tags: ['犯罪', '剧情', '扫黑', '国产剧'],
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    updateInfo: '全39集',
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-4',
    title: '奥本海默',
    category: 'movie',
    region: 'america',
    year: '2023',
    rating: 9.1,
    description: '聚焦"原子弹之父"罗伯特·奥本海默的传奇一生，讲述了他在曼哈顿计划中主导研制原子弹的震撼故事...',
    longDescription: '《奥本海默》由克里斯托弗·诺兰执导，聚焦美国"原子弹之父"罗伯特·奥本海默的传奇一生。影片以IMAX胶片摄影机拍摄，讲述了奥本海默在曼哈顿计划中主导研制世界上第一颗原子弹的故事，以及他在战后面临的政治审查与道德拷问。基里安·墨菲的表演令人震撼，配乐由路德维格·戈兰松创作，视听体验极为震撼。',
    coverImage: 'https://readdy.ai/api/search-image?query=Oppenheimer%20movie%20poster%20style%2C%20man%20in%20fedora%20hat%20silhouette%20against%20nuclear%20explosion%2C%20black%20and%20orange%20fire%20background%2C%20dramatic%20contrast%2C%20minimal%20design%2C%20dark%20atmosphere%2C%20cinematic%20quality&width=600&height=800&seq=movie-cover-4&orientation=portrait',
    tags: ['传记', '历史', '剧情', '好莱坞'],
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙'],
    updateInfo: 'HD高清中字',
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-5',
    title: '海贼王',
    category: 'anime',
    region: 'japan',
    year: '1999',
    rating: 9.8,
    description: '少年路飞为了成为海贼王，踏上寻找传说中"One Piece"的冒险旅程，与伙伴们在大海上展开热血篇章...',
    longDescription: '《海贼王》是日本漫画家尾田荣一郎创作的少年漫画作品，改编的动画自1999年开始播出至今。故事讲述了少年蒙奇·D·路飞为了成为海贼王，踏上寻找传说中"One Piece"的冒险旅程。一路上结识了索隆、娜美、乌索普、山治等伙伴，组成了草帽海贼团。本作以其宏大的世界观、深刻的友情主题和热血战斗场面，成为全球最受欢迎的动漫之一。',
    coverImage: 'https://readdy.ai/api/search-image?query=One%20Piece%20anime%20poster%20style%2C%20young%20pirate%20boy%20with%20straw%20hat%20smiling%2C%20ocean%20background%20with%20pirate%20ship%2C%20bright%20blue%20sky%20and%20white%20clouds%2C%20colorful%20vibrant%20animation%20style%2C%20warm%20golden%20sunlight%2C%20adventure%20theme&width=600&height=800&seq=movie-cover-5&orientation=portrait',
    tags: ['热血', '冒险', '友情', '日漫'],
    director: '尾田荣一郎',
    actors: ['田中真弓', '中井和哉', '冈村明美'],
    updateInfo: '更新至1120集',
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-6',
    title: '繁花',
    category: 'tv',
    region: 'china',
    year: '2024',
    rating: 9.4,
    description: '九十年代的上海，阿宝在改革开放浪潮中从默默无闻到成为商界翘楚的传奇人生，讲述了一段荡气回肠的上海往事...',
    longDescription: '《繁花》由王家卫执导并监制，胡歌、马伊琍、唐嫣、辛芷蕾领衔主演。故事发生在上世纪九十年代初的上海，讲述了阿宝在改革开放的浪潮中，从一个默默无闻的年轻人成长为商界翘楚的传奇故事。剧中展现了上海黄河路的繁华与喧嚣，以及那个年代独特的人情世故。王家卫独特的美学风格和细腻的叙事手法，让这部剧成为了2024年最受瞩目的电视剧之一。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20series%20poster%20set%20in%201990s%20Shanghai%2C%20stylish%20man%20in%20suit%20walking%20on%20neon%20lit%20street%2C%20vintage%20Shanghai%20aesthetic%2C%20golden%20warm%20lighting%2C%20retro%20atmosphere%2C%20elegant%20composition%2C%20cinematic%20quality&width=600&height=800&seq=movie-cover-6&orientation=portrait',
    tags: ['剧情', '年代', '商战', '国产剧'],
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    updateInfo: '全30集',
    isHot: true,
    isNew: true,
  },
  {
    id: 'movie-7',
    title: '铃芽之旅',
    category: 'anime',
    region: 'japan',
    year: '2023',
    rating: 8.9,
    description: '生活在九州乡间的17岁少女铃芽，遇见了一名正在寻找"门"的神秘青年，开启了一段不可思议的旅程...',
    longDescription: '《铃芽之旅》是新海诚执导的动画电影，讲述了生活在九州乡间的17岁少女铃芽，遇见了一名正在寻找"门"的神秘青年。随后日本各地开始出现灾难之"门"，为了阻止灾难发生，铃芽踏上了一段不可思议的旅程。影片以精美的画面和动人的音乐，探讨了关于成长、失去与治愈的主题，是新海诚继《你的名字。》《天气之子》后的又一部力作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%2C%20young%20girl%20with%20long%20hair%20standing%20in%20beautiful%20landscape%20with%20magical%20door%2C%20bright%20blue%20sky%20with%20dramatic%20clouds%2C%20anime%20art%20style%20with%20vibrant%20colors%2C%20dreamy%20atmosphere%2C%2C%20warm%20sunlight&width=600&height=800&seq=movie-cover-7&orientation=portrait',
    tags: ['动画', '奇幻', '冒险', '日漫'],
    director: '新海诚',
    actors: ['原菜乃华', '松村北斗', '深津绘里'],
    updateInfo: 'HD高清',
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-8',
    title: '封神第一部',
    category: 'movie',
    region: 'china',
    year: '2023',
    rating: 8.8,
    description: '商王殷寿暴虐无道，妲己祸乱朝纲。昆仑仙人姜子牙携"封神榜"下山，一场关乎天下苍生的封神大战即将展开...',
    longDescription: '《封神第一部：朝歌风云》由乌尔善执导，费翔、李雪健、黄渤、于适等主演。影片取材于中国古典神魔小说《封神演义》，讲述了商王殷寿与狐妖妲己勾结，暴虐无道，引发天谴。昆仑仙人姜子牙携"封神榜"下山，寻找天下共主以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌。本片以宏大的制作规模和精良的视觉效果，重新演绎了中国神话经典。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%2C%20ancient%20Chinese%20warriors%20in%20armor%20on%20battlefield%2C%20epic%20scale%20with%20mythical%20creatures%2C%20gold%20and%20crimson%20color%20scheme%2C%20dramatic%20cloud%20background%2C%20traditional%20Chinese%20elements%2C%20cinematic&width=600&height=800&seq=movie-cover-8&orientation=portrait',
    tags: ['奇幻', '神话', '史诗', '国产大片'],
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    updateInfo: 'HD高清',
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-9',
    title: '向往的生活',
    category: 'variety',
    region: 'china',
    year: '2024',
    rating: 8.6,
    description: '在远离城市喧嚣的蘑菇屋里，和朋友们一起种地、做饭、聊天，回归最纯粹的生活本质...',
    longDescription: '《向往的生活》是一档大型生活服务纪实节目，记录了何炅、黄磊等人来到远离城市喧嚣的乡村，在"蘑菇屋"里自力更生、自给自足的生活。节目中嘉宾们需要自己去田地里采摘食材、搭炉灶、生火做饭，用劳动换取食物。通过最朴实的田园生活，展现人与自然、人与人之间的温情互动，让观众在快节奏的都市生活中找到片刻宁静。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20countryside%20cottage%20with%20green%20fields%20and%20mountains%2C%20warm%20rustic%20atmosphere%2C%20friends%20gathering%20around%20wooden%20table%20outdoors%2C%20golden%20sunset%20lighting%2C%20peaceful%20pastoral%20scene%2C%20natural%20color%20palette&width=600&height=800&seq=movie-cover-9&orientation=portrait',
    tags: ['真人秀', '生活', '美食', '综艺'],
    director: '',
    actors: ['何炅', '黄磊', '张艺兴', '彭昱畅'],
    updateInfo: '更新至2024-08-01期',
    isHot: false,
    isNew: true,
  },
  {
    id: 'movie-10',
    title: '寄生虫',
    category: 'movie',
    region: 'korea',
    year: '2019',
    rating: 9.3,
    description: '一个贫穷的四口之家，通过精心的伪装和计划，陆续进入了富裕家庭工作，但意想不到的事件打破了表面的平静...',
    longDescription: '《寄生虫》是奉俊昊执导的韩国剧情片，荣获第92届奥斯卡金像奖最佳影片等四项大奖。影片讲述了住在半地下室的一家四口，通过精心伪装陆续进入富裕的朴社长家工作后发生的故事。影片以黑色幽默的手法，深刻揭示了社会阶层的固化和贫富差距的现实问题。宋康昊等演员的精湛演技和奉俊昊出色的导演功力，让这部影片成为影史经典。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20movie%20Parasite%20style%20poster%2C%20dark%20thriller%20atmosphere%2C%20contrast%20between%20wealthy%20modern%20house%20and%20poor%20basement%2C%20family%20portrait%20with%20hidden%20tension%2C%20black%20and%20dark%20green%20color%20scheme%2C%20minimal%20but%20striking%20design&width=600&height=800&seq=movie-cover-10&orientation=portrait',
    tags: ['剧情', '悬疑', '黑色幽默', '奥斯卡'],
    director: '奉俊昊',
    actors: ['宋康昊', '李善均', '赵汝贞', '崔宇植'],
    updateInfo: 'HD高清中字',
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-11',
    title: '庆余年第二季',
    category: 'tv',
    region: 'china',
    year: '2024',
    rating: 9.0,
    description: '范闲从北齐归来后，面对更加复杂的朝堂局势和江湖恩怨，继续书写他的传奇人生...',
    longDescription: '《庆余年第二季》延续第一季的故事，范闲从北齐归来后，面对更加复杂的朝堂局势和江湖恩怨。二皇子、长公主等势力的暗中较量愈发激烈，范闲不得不在各方势力之间周旋。与此同时，他也在一步步揭开自己身世的秘密。本季由张若昀、李沁、陈道明等原班人马出演，剧情更加扣人心弦，制作水准全面升级。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20series%20poster%2C%20handsome%20man%20in%20traditional%20Chinese%20robe%20holding%20sword%2C%20ancient%20palace%20background%2C%20dramatic%20golden%20and%20red%20lighting%2C%20epic%20composition%2C%20refined%20aesthetic%2C%20cinematic%20quality&width=600&height=800&seq=movie-cover-11&orientation=portrait',
    tags: ['古装', '权谋', '奇幻', '国产剧'],
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    updateInfo: '全36集',
    isHot: false,
    isNew: true,
  },
  {
    id: 'movie-12',
    title: '地球脉动第三季',
    category: 'documentary',
    region: 'europe',
    year: '2023',
    rating: 9.8,
    description: 'BBC自然纪录片巅峰之作，探索地球上最壮丽的自然奇观和野生动物的生存智慧...',
    longDescription: '《地球脉动第三季》是BBC倾力打造的自然纪录片系列最新力作。由大卫·爱登堡爵士担任解说，摄制组历时五年，深入地球各个角落，用超高清镜头记录下了前所未见的自然奇观。从深海到丛林，从极地到沙漠，每一帧画面都令人叹为观止。本季首次大量运用了无人机和微距摄影技术，为观众呈现了一个更加真实细腻的地球生命世界。',
    coverImage: 'https://readdy.ai/api/search-image?query=BBC%20nature%20documentary%20poster%2C%20stunning%20aerial%20view%20of%20Earth%20landscape%20with%20diverse%20wildlife%2C%20ocean%20and%20mountains%20and%20forests%2C%20vibrant%20natural%20colors%2C%20breathtaking%20cinematic%20photography%2C%20rich%20emerald%20green%20and%20deep%20blue%20tones&width=600&height=800&seq=movie-cover-12&orientation=portrait',
    tags: ['自然', '纪录片', 'BBC', '4K'],
    director: '',
    actors: ['大卫·爱登堡'],
    updateInfo: 'HD高清中字',
    isHot: false,
    isNew: false,
  },
];

export const heroMovies = movies.filter(m => m.isHot).slice(0, 5);
export const hotMovies = movies.filter(m => m.isHot);
export const newMovies = movies.filter(m => m.isNew);
export const featuredCollections = [
  {
    id: 'collection-1',
    title: '国产科幻大片',
    description: '中国科幻电影的崛起之路',
    movieIds: ['movie-1', 'movie-8'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20collection%20banner%2C%20futuristic%20cityscape%20with%20Chinese%20elements%2C%20massive%20space%20station%2C%20orange%20and%20teal%20color%20grading%2C%20cinematic%20wide%20shot%2C%20epic%20scale%2C%20clean%20composition&width=800&height=400&seq=collection-1&orientation=landscape',
  },
  {
    id: 'collection-2',
    title: '日漫经典必看',
    description: '陪伴一代人成长的经典之作',
    movieIds: ['movie-5', 'movie-7'],
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20collection%20banner%2C%20colorful%20anime%20characters%20collage%2C%20bright%20vibrant%20colors%2C%20dynamic%20composition%2C%20warm%20sunlight%20and%20blue%20sky%2C%20adventure%20and%20friendship%20theme%2C%20eye-catching%20design&width=800&height=400&seq=collection-2&orientation=landscape',
  },
  {
    id: 'collection-3',
    title: '奥斯卡获奖影片',
    description: '影史留名的经典佳作',
    movieIds: ['movie-4', 'movie-10'],
    image: 'https://readdy.ai/api/search-image?query=Oscar%20award%20winning%20films%20collection%20banner%2C%20elegant%20golden%20statue%20silhouette%20with%20film%20reel%2C%20classic%20Hollywood%20glamour%2C%20dark%20sophisticated%20background%2C%20gold%20accents%2C%20premium%20cinematic%20aesthetic&width=800&height=400&seq=collection-3&orientation=landscape',
  },
];